import { telefonoBonito } from "../../../utils/telefonoBonito";
/** Textos y utilidades de Ventas. Todo el texto de la pantalla en español, aquí. */

export const ETAPAS: { id: number; name: string }[] = [
	{ id: 1, name: "Pre-Inscripción" }, { id: 2, name: "Matriculado" }, { id: 3, name: "Retirado" }, { id: 4, name: "Graduado" }
];

/*
	El riel de vistas. Son los filtros que Esteban pidió (2026-09-19), agrupados.
	La "alerta" pinta el conteo en oro (lo que ya se atrasó).
*/
export const VISTAS: { grupo: string; items: { key: string; label: string; alerta?: boolean; fuerte?: boolean }[] }[] = [
	{
		grupo: "Entradas nuevas", items: [
			{ key: "sin_atender", label: "Sin atender", fuerte: true },
			{ key: "creaciones_hoy", label: "Creaciones hoy" },
			{ key: "creaciones_ayer", label: "Ayer" },
			{ key: "creaciones_semana", label: "Esta semana" },
			{ key: "creaciones_mes", label: "Este mes" },
			{ key: "sin_movimiento", label: "Sin movimiento aún", alerta: true },
			{ key: "me_los_pasaron", label: "Me los pasaron", fuerte: true },
		]
	},
	{
		grupo: "Status", items: [
			{ key: "promesas", label: "Promesas" },
			{ key: "interesados", label: "Interesados" },
			{ key: "potencial", label: "Potencial · Prospecto" },
		]
	},
	{
		grupo: "Seguimientos", items: [
			{ key: "vencidas", label: "Vencidos", alerta: true },
			// Ventana abierta (Esteban, 2026-10-14): el cliente escribió en las últimas 24 h, se contesta libre.
			{ key: "ventana_abierta", label: "Ventana Abierta" },
			{ key: "hoy", label: "Hoy" },
			{ key: "manana", label: "Mañana" },
			{ key: "semana", label: "Resto de la semana" },
		]
	},
	{
		grupo: "Sin nota hace", items: [
			{ key: "sin_nota_5", label: "5 días o más" },
			{ key: "sin_nota_10", label: "10 días o más" },
			{ key: "sin_nota_30", label: "30 días o más", alerta: true },
		]
	},
	{
		grupo: "Alertas", items: [
			{ key: "quitaron_seguimiento", label: "Le quitaron seguimiento", alerta: true },
			{ key: "nuevo_3_notas", label: "Nuevo cliente con 3+ notas", alerta: true },
		]
	},
];

/* El riel cambia con la Etapa (lienzo): Matriculado ve oportunidades y retención; Retirado, reingreso. */
export const VISTAS_MATRICULADO: typeof VISTAS = [
	{
		grupo: "Oportunidades", items: [
			{ key: "califican_promo", label: "Califican a promo", fuerte: true },
			{ key: "abonos_kit", label: "Abonos sin liquidar" },
			{ key: "sin_producto", label: "Sin producto" },
			{ key: "terminan_modulo", label: "Terminan módulo < 30 d" },
			{ key: "inscritos_recientes", label: "Inscritos recientes" },
		]
	},
	{
		grupo: "Retención", items: [
			{ key: "mensualidad_vencida", label: "Mensualidad vencida", alerta: true },
			{ key: "faltas_3", label: "3 faltas o más en 30 días", alerta: true },
			{ key: "riesgo_retiro", label: "Riesgo de retiro", alerta: true },
		]
	},
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "ventana_abierta", label: "Ventana Abierta" }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }, { key: "semana", label: "Resto de la semana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }, { key: "sin_gestion", label: "Sin gestión activa" }] },
];
export const VISTAS_RETIRADO: typeof VISTAS = [
	{
		grupo: "Reingreso", items: [
			{ key: "retiro_1_6", label: "Se retiraron hace 1–6 meses", fuerte: true },
			{ key: "retiro_6_12", label: "6–12 meses" },
			{ key: "retiro_12", label: "Más de un año" },
			{ key: "retiro_sin_saldo", label: "Sin saldo pendiente" },
			{ key: "retiro_con_saldo", label: "Con saldo", alerta: true },
		]
	},
	{
		grupo: "Motivo de retiro", items: [
			{ key: "retiro_economico", label: "Económico" },
			{ key: "retiro_trabajo", label: "Trabajo · horario" },
			{ key: "retiro_salud", label: "Salud · viaje" },
			{ key: "retiro_sin_motivo", label: "Sin motivo registrado" },
		]
	},
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "ventana_abierta", label: "Ventana Abierta" }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }] },
];
export const VISTAS_GRADUADO: typeof VISTAS = [
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "ventana_abierta", label: "Ventana Abierta" }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }, { key: "sin_gestion", label: "Sin gestión activa" }] },
];
export const vistasDeEtapa = (etapa: number): typeof VISTAS => etapa === 2 ? VISTAS_MATRICULADO : etapa === 3 ? VISTAS_RETIRADO : etapa === 4 ? VISTAS_GRADUADO : VISTAS;

/**
 * WappChat (Esteban, 2026-10-04): "Filtros" en una sola lista, sin categorías. Los de uso diario arriba y el resto en
 * "Más filtros". Sin el grupo, algunas etiquetas necesitan decir de qué hablan ("Hoy" → "Para hoy").
 */
type Filtro = { key: string; label: string; alerta?: boolean; fuerte?: boolean };
const FILTROS_ETAPA: { [etapa: number]: { top: string[]; labels: { [k: string]: string } } } = {
	1: {
		top: ["sin_atender", "vencidas", "ventana_abierta", "hoy", "manana", "me_los_pasaron", "promesas", "interesados", "creaciones_hoy", "sin_movimiento", "quitaron_seguimiento"],
		labels: { hoy: "Para hoy", manana: "Para mañana", creaciones_hoy: "Creados hoy", creaciones_ayer: "Creados ayer", creaciones_semana: "Creados esta semana",
			creaciones_mes: "Creados este mes", potencial: "Potencial", sin_nota_5: "Sin nota 5 días o más", sin_nota_10: "Sin nota 10 días o más",
			sin_nota_30: "Sin nota 30 días o más", nuevo_3_notas: "Nuevos con 3 notas o más" },
	},
	2: {
		top: ["mensualidad_vencida", "faltas_3", "riesgo_retiro", "califican_promo", "vencidas", "ventana_abierta", "hoy", "recontacto"],
		labels: { vencidas: "Vencidos", hoy: "Para hoy", manana: "Para mañana", faltas_3: "3 faltas o más en 30 días", terminan_modulo: "Terminan módulo en menos de 30 días" },
	},
	3: {
		top: ["retiro_1_6", "retiro_con_saldo", "vencidas", "ventana_abierta", "hoy", "recontacto"],
		labels: { retiro_1_6: "Retirados hace 1 a 6 meses", retiro_6_12: "Retirados hace 6 a 12 meses", retiro_12: "Retirados hace más de un año",
			retiro_sin_saldo: "Retirados sin saldo", retiro_con_saldo: "Retirados con saldo", retiro_economico: "Motivo económico",
			retiro_trabajo: "Motivo trabajo u horario", retiro_salud: "Motivo salud o viaje", retiro_sin_motivo: "Sin motivo de retiro",
			vencidas: "Vencidos", hoy: "Para hoy", manana: "Para mañana" },
	},
	4: { top: ["vencidas", "ventana_abierta", "hoy", "manana", "recontacto", "promesas", "sin_gestion"], labels: { vencidas: "Vencidos", hoy: "Para hoy", manana: "Para mañana" } },
};
export const filtrosDeEtapa = (etapa: number): { top: Filtro[]; mas: Filtro[] } => {
	const cfg = FILTROS_ETAPA[etapa] || FILTROS_ETAPA[1];
	const todos: Filtro[] = [];
	vistasDeEtapa(etapa).forEach((g) => g.items.forEach((i) => { if (!todos.some((t) => t.key === i.key)) todos.push({ ...i, label: cfg.labels[i.key] || i.label }); }));
	const top = cfg.top.map((k) => todos.find((t) => t.key === k)).filter(Boolean) as Filtro[];
	return { top, mas: todos.filter((t) => !cfg.top.includes(t.key)) };
};
/** Varias Etapas (WappChat): los filtros de todas; arriba los de diario, el resto en "Más". Spam al final (sin conteo). */
const TOP_VARIAS = ["sin_atender", "vencidas", "ventana_abierta", "hoy", "manana", "me_los_pasaron", "promesas", "interesados", "recontacto"];
export const SPAM: Filtro = { key: "spam", label: "Spam" };
export const filtrosDeEtapas = (etapas: number[]): { top: Filtro[]; mas: Filtro[] } => {
	if (etapas.length === 1) {
		const f = filtrosDeEtapa(etapas[0]);
		return { top: f.top, mas: [...f.mas, SPAM] };
	}
	const todos: Filtro[] = [];
	etapas.forEach((e) => { const f = filtrosDeEtapa(e); [...f.top, ...f.mas].forEach((x) => { if (!todos.some((t) => t.key === x.key)) todos.push(x); }); });
	const top = TOP_VARIAS.map((k) => todos.find((t) => t.key === k)).filter(Boolean) as Filtro[];
	return { top, mas: [...todos.filter((t) => !TOP_VARIAS.includes(t.key)), SPAM] };
};
export const etiquetaFiltros = (etapas: number[], key: string | null): string => {
	if (!key) return "Todos";
	const f = filtrosDeEtapas(etapas);
	return [...f.top, ...f.mas].find((x) => x.key === key)?.label || TITULO_VISTA(key);
};

export const etiquetaFiltro = (etapa: number, key: string | null): string => {
	if (!key) return "Todos";
	const f = filtrosDeEtapa(etapa);
	return [...f.top, ...f.mas].find((x) => x.key === key)?.label || TITULO_VISTA(key);
};

export const TITULO_VISTA = (key: string | null): string => {
	if (!key) return "Todos";
	for (const v of [VISTAS, VISTAS_MATRICULADO, VISTAS_RETIRADO, VISTAS_GRADUADO]) for (const g of v) for (const i of g.items) if (i.key === key) return (g.grupo === "Sin nota hace" ? "Sin nota hace " : "") + i.label;
	return "Todos";
};

/** Dinero como lo escribe el equipo: "L 1,500.00" · "$ 2,000.00". */
export const dinero = (v: number | null | undefined, simbolo = ""): string =>
	v === null || v === undefined ? "—" : (simbolo ? simbolo + " " : "") + Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const SIMBOLO_PLANTEL: { [k: number]: string } = { 1: "$", 2: "$", 3: "L", 4: "L", 5: "L", 7: "US$" };

export const statusClase = (statusId: number): string =>
	({ 1: "nuevo", 2: "recontacto", 3: "interesado", 4: "promesa", 9: "matriculado" } as any)[statusId] || "";

export const etapaClase = (etapaId: number): string =>
	({ 1: "etapa1", 2: "matriculado", 3: "retirado", 4: "graduado" } as any)[etapaId] || "";

export const KIND_LABEL: { [k: string]: string } = {
	nota: "Nota", llamada: "Llamada", whatsapp: "WhatsApp", tarea: "Tarea", cambio: "Cambio",
	asignacion: "Asignación", promo: "Promo", sistema: "Sistema"
};

export const KIND_FILTROS: { key: string; label: string; kinds: string[] }[] = [
	// Lo de entrada es la conversación (mensajes y llamadas): las notas son internas y viven en la Ficha (Esteban, 2026-10-06).
	{ key: "conversacion", label: "Conversación", kinds: ["whatsapp", "llamada"] },
	{ key: "todo", label: "Todo", kinds: [] },
	{ key: "notas", label: "Notas", kinds: ["nota"] },
	{ key: "llamadas", label: "Llamadas", kinds: ["llamada"] },
	{ key: "whatsapp", label: "WhatsApp", kinds: ["whatsapp"] },
	{ key: "tareas", label: "Tareas", kinds: ["tarea"] },
	{ key: "movimientos", label: "Movimientos", kinds: ["cambio", "asignacion"] },
];

export const ORIGEN_LABEL: { [k: string]: string } = { zoho: "Zoho", wapp: "WAPP", router: "Bot", audit: "Zoho", vozmia: "VozMia" };

/** El servidor guarda UTC ("2026-09-24 19:06:06") → Date. */
const parse = (v: string | null | undefined): Date | null => {
	if (!v) return null;
	const d = new Date(v.replace(" ", "T") + (/[zZ]|[+-]\d\d:?\d\d$/.test(v) ? "" : "Z"));
	return isNaN(d.getTime()) ? null : d;
};

/*
	Se muestra siempre en hora de Ciudad de México (= Honduras): UTC-6 todo el año, sin horario de verano desde 2022.
	Así una supervisora que abre WAPP de viaje ve lo mismo que la asesora en el plantel.
*/
const MX_MS = 6 * 3600000;
const mx = (d: Date) => {
	const t = new Date(d.getTime() - MX_MS);
	return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate(), h: t.getUTCHours(), mi: t.getUTCMinutes(),
		dia: Math.floor((d.getTime() - MX_MS) / 86400000) };
};

// El mes siempre con mayúscula: "12 Oct" (Esteban, 2026-10-06).
const MESES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
const hora12 = (h: number, mi: number) => `${h % 12 || 12}:${String(mi).padStart(2, "0")} ${h < 12 ? "am" : "pm"}`;

/** Fecha corta como en el resto de WAPP: "hoy 11:04", "ayer 16:22", "12 sep", "mar 2019". */
export const cuando = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "—";
	const f = mx(d), hoy = mx(new Date());
	const diff = hoy.dia - f.dia;
	if (diff === 0) return "hoy " + hora12(f.h, f.mi);
	if (diff === 1) return "ayer " + hora12(f.h, f.mi);
	if (diff === -1) return "mañana " + hora12(f.h, f.mi);
	if (f.y === hoy.y) return `${f.d} ${MESES[f.m]}`;
	return `${MESES[f.m]} ${f.y}`;
};

export const fechaLarga = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "—";
	const f = mx(d);
	return `${f.d} ${MESES[f.m]} ${f.y}, ${hora12(f.h, f.mi)}`;
};

/** Fecha sin hora de Zoho ("2026-09-24", vencimiento de tarea): se muestra tal cual, sin mover de zona. */
export const fechaDia = (v: string | null | undefined): string => {
	const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
	return m ? `${Number(m[3])} ${MESES[Number(m[2]) - 1]} ${m[1]}` : (v || "—");
};

export const anio = (v: string | null | undefined): number | null => {
	const d = parse(v);
	return d ? mx(d).y : null;
};

export const esteAnio = (): number => mx(new Date()).y;

export const vencido = (v: string | null | undefined): boolean => {
	const d = parse(v);
	return !!d && d.getTime() < Date.now();
};

/** Valor de <input type="datetime-local"> (hora de México) → ISO UTC para el servidor. */
/** El iPhone puede dar la fecha con segundos ("2026-10-05T00:53:00"): solo se toman fecha, hora y minutos. */
export const localMxAIso = (v: string): string => {
	const m = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/.exec(v || "");
	if (!m) throw new Error("Elige la fecha y la hora.");
	return new Date(new Date(m[1] + "T" + m[2] + ":00Z").getTime() + MX_MS).toISOString();
};

/**
 * ¿Su nombre de WhatsApp parece nombre? ".", "😍😍", "~~" o un número no (Esteban, 2026-10-06: "es más profesional y
 * ordenado solo poner WhatsApp 9293243"). Hacen falta al menos dos letras y más letras que otra cosa.
 */
// Saludos y palabras sueltas que la gente pone de perfil y no son nombre (misma lista que App\\Common\\NombreWa).
const NO_SON = ["hola", "holi", "buenas", "buenos dias", "buenas tardes", "info", "informacion", "cliente", "usuario", "whatsapp", "ok", "yo", "mi familia", "familia", "mama", "papa", "amor", "business", "negocio", "ventas"];
export const pareceNombre = (t?: string | null): boolean => {
	const s = limpiarWa(t), letras = (s.match(/\p{L}/gu) || []).length;
	if (NO_SON.includes(s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z ]/g, "").trim())) return false;   // "Hola", "Info"…
	return letras >= 3 && letras >= s.replace(/[\p{L}\p{M}\s.'’-]/gu, "").length;
};
/** Su nombre de WhatsApp sin emojis ni adornos, para ponerlo como nombre: "🌺Jen🌺" -> "Jen", "Kenny Alvarez 🌵🩶" -> "Kenny Alvarez". */
export const limpiarWa = (t?: string | null): string =>
	(t || "").replace(/[\p{Extended_Pictographic}\p{Emoji_Modifier}\u200d\ufe0f\u20e3]/gu, "").replace(/^[\s~*_.]+|[\s~*_]+$/g, "").replace(/\s+/g, " ").trim()
		.replace(/^[^\p{Lu}]*$/u, (m) => m.replace(/(^|\s)(\p{L})/gu, (x) => x.toUpperCase()));   // "karolina" -> "Karolina"
/** Dice algo (letras o emojis), no solo puntos o números: vale la pena enseñarlo abajo del nombre. */
export const waDiceAlgo = (t?: string | null): boolean => /[\p{L}\p{Extended_Pictographic}]/u.test(t || "");
/** "WhatsApp 81 1187 5019": cuando no hay nombre que poner. La lada va en la columna Móvil. */
export const nombreWa = (tel?: string | null): string => tel ? "WhatsApp " + telefonoBonito(tel).replace(/^\+\d{1,3}\s+/, "").replace(/[\s-]/g, "") : "Sin nombre";

/**
 * El nombre de una persona, IGUAL en todas las pantallas (CRM, ficha, WappChat, Equipo) (Esteban, 2026-10-06: "tienen un
 * nombre en la lista de clientes y otro en WappChat... tienes que ser consistente"): su nombre; si no tiene, su nombre de
 * WhatsApp cuando parece nombre (sin emojis); si no, "WhatsApp 99728032".
 */
export const nombreCompleto = (p: { first_name?: string | null; last_name?: string | null; wa_nombre?: string | null; phone_e164?: string | null }): string => {
	const real = nombreReal(p);
	if (real) return real;
	return pareceNombre(p.wa_nombre) ? limpiarWa(p.wa_nombre) : nombreWa(p.phone_e164);
};

export const errorTexto = (e: any): string =>
	e?.response?.data?.message || e?.message || "No se pudo completar. Intenta otra vez.";

/** Etiqueta del día para separar la conversación: "hoy", "ayer", "martes 22 sep", "12 mar 2024". */
const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
export const diaEtiqueta = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const f = mx(d), hoy = mx(new Date());
	const diff = hoy.dia - f.dia;
	if (diff === 0) return "hoy";
	if (diff === 1) return "ayer";
	const dow = DIAS[new Date(Date.UTC(f.y, f.m, f.d)).getUTCDay()];
	if (diff > 1 && diff < 7) return `${dow} ${f.d} ${MESES[f.m]}`;
	return f.y === hoy.y ? `${f.d} ${MESES[f.m]}` : `${f.d} ${MESES[f.m]} ${f.y}`;
};
export const diaClave = (v: string | null | undefined): number => { const d = parse(v); return d ? mx(d).dia : 0; };

/** Solo la hora, en hora de México: "9:31 am". */
export const hora = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const f = mx(d);
	return hora12(f.h, f.mi);
};

/** Cuánto falta para que cierre la ventana de 24 h: "6 h 12 min". */
export const faltan = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const min = Math.max(0, Math.round((d.getTime() - Date.now()) / 60000));
	return min >= 60 ? `${Math.floor(min / 60)} h ${min % 60} min` : `${min} min`;
};

/** "kind|direction|texto" de la bandeja → texto corto como en el mockup. */
/** "[Foto]" -> "📷 Foto", "[Nota de voz]" -> "🎤 Nota de voz"…: como se ve en la lista de chats de WhatsApp (Esteban, 2026-10-06). */
const ICONOS: [RegExp, string][] = [
	[/^\[Foto\]$/i, "📷 Foto"], [/^\[Imagen\]$/i, "📷 Foto"], [/^\[(Nota de voz|Audio)\]$/i, "🎤 Nota de voz"], [/^\[Video\]$/i, "🎥 Video"],
	[/^\[Sticker\]$/i, "💟 Sticker"], [/^\[GIF\]$/i, "🎞️ GIF"], [/^\[Documento(?:: (.+))?\]$/i, "📄 $1"], [/^\[Ubicación(?:: (.+))?\]$/i, "📍 $1"],
	[/^\[Contacto: (.+)\]$/i, "👤 $1"],
	[/^\[(Mensaje unsupported|Unsupported_message)\]$/i, "⚠️ Mensaje no disponible"],
];
export const conIcono = (t: string): string => {
	for (const [re, rep] of ICONOS) if (re.test(t)) return t.replace(re, rep).replace(/ \$1$|\s+$/, "").replace(/^(📄|📍)\s*$/, (x) => x + (x.startsWith("📄") ? " Documento" : " Ubicación"));
	return t;
};

/** Primer nombre de quien mandó el último mensaje ("María: …"); los envíos automáticos no llevan nombre de persona. */
const quienMando = (by: string | null | undefined): string => {
	const n = (by || "").trim().split(/\s+/)[0] || "";
	return !n || /^(sistema|woztell|ia|router|wapp)$/i.test(n) ? "Equipo" : n;
};

/** Vista previa de la fila: mensaje o llamada (las llamadas van en cursiva con su ícono; la perdida entrante, en oro). */
export const vistaPrevia = (v: string | null | undefined, by?: string | null): { texto: string; llamada: null | "normal" | "perdida" } => {
	if (!v) return { texto: "", llamada: null };
	const [kind, dir, ...rest] = v.split("|");
	const t = rest.join("|").replace(/\s+/g, " ").trim();
	if (kind === "llamada") return { texto: t || "Llamada", llamada: dir === "in" && /no contest|perdida|buz/i.test(t) ? "perdida" : "normal" };
	if (kind === "whatsapp") { const m = conIcono(t); return { texto: dir === "out" ? quienMando(by) + ": " + m : m, llamada: null }; }
	return { texto: t, llamada: null };
};

export const ultimoMensaje = (v: string | null | undefined): string => {
	if (!v) return "";
	const [kind, dir, ...rest] = v.split("|");
	const t = rest.join("|").replace(/\s+/g, " ").trim();
	if (kind === "whatsapp") { const m = conIcono(t); return dir === "out" ? "Tú: " + m : m; }
	if (kind === "nota") return "Nota: " + t;
	if (kind === "llamada") return t;
	return t;
};

export const RESULTADOS_LLAMADA: { key: string; label: string }[] = [
	// "Me colgó" (Esteban, 2026-10-14): contestó y colgó enseguida; antes caía sola como "No contestó".
	{ key: "contesto", label: "Contestó" }, { key: "colgo", label: "Me colgó" }, { key: "no_contesto", label: "No contestó" }, { key: "buzon", label: "Buzón" },
	{ key: "ocupado", label: "Ocupado" }, { key: "cortada", label: "Se cortó" }, { key: "equivocado", label: "Número equivocado" },
];

export const GENEROS: { id: number; name: string }[] = [{ id: 1, name: "Hombre" }, { id: 2, name: "Mujer" }];

/** Quita acentos y minúsculas, para empatar "Repostería" con "reposteria / pasteleria". */
export const plano = (s: string | null | undefined): string =>
	(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

/* Barra de arriba (lienzo): Objetivo y Día · Mañana · Tarde. El objetivo es la regla de WAPP que lo define
   (promo = le aplica una, kit = debe o no tiene, retención = vencida o faltas) o una gestión abierta con ese objetivo. */
export const OBJETIVOS_BARRA: { key: string; label: string; etapas: number[] }[] = [
	{ key: "inscripcion", label: "Inscripción", etapas: [1] },
	{ key: "promo", label: "Promo", etapas: [2] },
	{ key: "kit", label: "Kit", etapas: [2] },
	{ key: "mas_cursos", label: "Más cursos", etapas: [2, 4] },
	{ key: "retencion", label: "Retención", etapas: [2] },
	{ key: "reinscripcion", label: "Reinscripción", etapas: [3] },
];
export const GESTION_RESULTADOS: { key: string; label: string }[] = [
	{ key: "logrado", label: "Lo logró (pagó / se inscribió)" }, { key: "no_interesa", label: "No le interesa" },
	{ key: "no_contesta", label: "No contesta" }, { key: "despues", label: "Lo deja para después" }, { key: "otro", label: "Otro" },
];

/** La línea de la fila de Matriculado: "pagó 4 de 10 · PROMO 10x2 · KIT pendiente". */
export const resumenWapp = (w: { pagadas: number | null; meses: number | null; vencidas: number; promo: string | null; kit: string | null } | null | undefined): string => {
	if (!w) return "";
	const partes: string[] = [];
	if (w.meses) partes.push(`pagó ${w.pagadas ?? 0} de ${w.meses}`);
	if (w.vencidas > 0) partes.push(`${w.vencidas} vencida${w.vencidas === 1 ? "" : "s"}`);
	if (w.promo) partes.push("PROMO " + w.promo);
	if (w.kit) partes.push(w.kit === "abono" ? "KIT abono sin liquidar" : "KIT pendiente");
	return partes.join(" · ");
};

/**
 * Cuándo viene algo de "Lo que viene": "Hoy 4:30 pm", "Mañana", "Vie 9 oct", "Vencido 2 oct".
 * Acepta fecha-hora UTC del servidor o fecha sin hora ("2026-10-05", mensualidad de WAPP).
 */
export const cuandoViene = (v: string | null | undefined): { texto: string; tono: "vencido" | "hoy" | "pronto" | "despues"; orden: number } | null => {
	if (!v) return null;
	const soloDia = /^\d{4}-\d{2}-\d{2}$/.test(v);
	const d = soloDia ? new Date(v + "T12:00:00Z") : parse(v);
	if (!d) return null;
	const f = soloDia ? (() => { const t = new Date(d); return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate(), h: 0, mi: 0, dia: Math.floor(t.getTime() / 86400000) }; })() : mx(d);
	const hoy = mx(new Date());
	const diff = f.dia - hoy.dia;
	const h = soloDia ? "" : " " + hora12(f.h, f.mi);
	const fecha = `${f.d} ${MESES[f.m]}`;
	const orden = soloDia ? f.dia * 86400000 + 43200000 : d.getTime();
	if (diff < 0 || (!soloDia && d.getTime() < Date.now())) return { texto: "Vencido " + (diff === 0 ? hora12(f.h, f.mi) : fecha), tono: "vencido", orden };
	if (diff === 0) return { texto: "Hoy" + h, tono: "hoy", orden };
	if (diff === 1) return { texto: "Mañana" + h, tono: "pronto", orden };
	// "lun 12 oct" y luego "13 oct" no tenía sentido (Esteban, 2026-10-06): palabra completa (Hoy, Mañana) o la fecha.
	if (diff < 7) return { texto: fecha + h, tono: "pronto", orden };
	return { texto: f.y === hoy.y ? fecha : `${fecha} ${f.y}`, tono: "despues", orden };
};

/** Iniciales para el circulito de la lista de WappChat (como la foto de WhatsApp). */
export const iniciales = (p: { first_name?: string | null; last_name?: string | null; wa_nombre?: string | null }): string => {
	// Las mismas letras en todas las pantallas: de su nombre o, si no tiene, de su nombre de WhatsApp cuando parece nombre.
	const n = nombreReal(p) || (pareceNombre(p.wa_nombre) ? limpiarWa(p.wa_nombre) : "");
	const w = n.split(/\s+/).filter((x) => /\p{L}/u.test(x[0] || ""));
	return ((w[0]?.[0] || "") + (w[1]?.[0] || "")).toUpperCase() || "?";
};
/** Siempre el mismo tono para la misma persona. */
export const tonoAvatar = (id: number): string => "tono-" + (Math.abs(id) % 6);

/** Departamentos de WappChat (Bandejas.php). Caja y Cobros son uno solo. */
export const DEPTS_WAPP: { [k: string]: string } = { ventas: "Ventas", admisiones: "Admisiones", caja: "Caja y Cobros", kits: "Kits", academico: "Académico", rrhh: "RRHH" };

/**
 * El nombre del contacto y su nombre de WhatsApp van aparte (Esteban, 2026-10-06). "WhatsApp 92024849" es lo que
 * pone el router cuando no sabe el nombre: eso no es un nombre.
 */
export const nombreReal = (p: { first_name?: string | null; last_name?: string | null }): string | null => {
	const n = [p.first_name, p.last_name].map((x) => (x || "").trim()).filter(Boolean).join(" ");
	return !n || /^whats\s*app\s*\+?[\d\s-]+$/i.test(n) ? null : n;
};

/**
 * Lo tecleado ya vale una búsqueda: una palabra de 4+ letras o 4+ dígitos. Con 3 letras ("mar") el servidor casaba 86 mil
 * fichas por tecla (14-oct-2026); el servidor aplica la misma regla para buscar en toda la base.
 */
export const listoParaBuscar = (v: string): boolean => {
	if (v.replace(/\D/g, "").length >= 4) return true;
	return v.split(/\s+/).some((w) => w.replace(/[^\p{L}]/gu, "").length >= 4);
};
